export default "__VITE_ASSET__CXllvD6M__"